export { SalesQueueViewComponent } from "./sales-queue-view/sales-queue-view.component";
export { SalesQueueAdminComponent } from "./sales-queue-admin/sales-queue-admin.component";
export {
  SalesQueueDisplayComponent
} from "./sales-queue-display/sales-queue-display.component";
